<template>
    <div class="page page-home">
    
        <Top></Top>

        <div class="hidden-lg hidden-xl navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back()" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Configurar horários</div>
                <div class="right">
                    <a style="opacity: 0;" class="link"> 
                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7 11.717C16.6839 10.9476 17.4031 9.89041 17.7575 8.69276C18.1118 7.49511 18.0836 6.21673 17.6767 5.03589C17.2698 3.85506 16.5046 2.83063 15.4877 2.10546C14.4708 1.38028 13.253 0.990524 12.004 0.990524C10.755 0.990524 9.53719 1.38028 8.52031 2.10546C7.50342 2.83063 6.73819 3.85506 6.33131 5.03589C5.92443 6.21673 5.89619 7.49511 6.25053 8.69276C6.60487 9.89041 7.32413 10.9476 8.308 11.717C6.44917 12.4566 4.85467 13.7363 3.73027 15.391C2.60587 17.0457 2.00318 18.9994 2 21V22C2 22.2652 2.10536 22.5196 2.29289 22.7071C2.48043 22.8946 2.73478 23 3 23H21C21.2652 23 21.5196 22.8946 21.7071 22.7071C21.8946 22.5196 22 22.2652 22 22V21C21.9975 19.0003 21.3959 17.0473 20.273 15.3927C19.1501 13.7381 17.5573 12.4579 15.7 11.717ZM8 7C8 6.20887 8.2346 5.43551 8.67412 4.77772C9.11365 4.11992 9.73836 3.60723 10.4693 3.30448C11.2002 3.00173 12.0044 2.92252 12.7804 3.07686C13.5563 3.2312 14.269 3.61216 14.8284 4.17157C15.3878 4.73098 15.7688 5.44371 15.9231 6.21964C16.0775 6.99556 15.9983 7.79983 15.6955 8.53073C15.3928 9.26163 14.8801 9.88635 14.2223 10.3259C13.5645 10.7654 12.7911 11 12 11C10.9391 11 9.92172 10.5786 9.17157 9.82842C8.42143 9.07828 8 8.06086 8 7ZM4 21C4 18.8783 4.84285 16.8434 6.34315 15.3431C7.84344 13.8428 9.87827 13 12 13C14.1217 13 16.1566 13.8428 17.6569 15.3431C19.1571 16.8434 20 18.8783 20 21H4Z" fill="#000"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        
        <div class="page-content pt-50 pb-100">


            <div class="container hidden-xs hidden-md">
                <h2>Configurar horários</h2>
            </div>


            <div class="container">
                <form method="post" v-on:submit.prevent="submit" novalidate="">
                    <div class="row">
                        <div class="col-100 mb-20">
                            <p>Configure abaixo o seu <b>horário de atendimento</b> para cada dia da semana.</p>
                            <hr style="opacity: 0.5;">
                        </div>

                        <div class="clearfix col-100 row" v-for="(item, index) in form.itens">
                            <div class="col-100 mb-10" :id="'data-' + index">
                               
                                <div class="headline" style="display: block !important;">
                                    <h3 class="mb-0 mt-0" v-if="index == 'd0'">Domingo</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd1'">Segunda-feira</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd2'">Terça-feira</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd3'">Quarta-feira</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd4'">Quinta-feira</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd5'">Sexta</h3>
                                    <h3 class="mb-0 mt-0" v-if="index == 'd6'">Sábado</h3>                                    
                                </div>

                                <div class="list" style="margin-top: 10px; margin-bottom: 10px" v-if="form.itens[index].length > 0">
                                    <ul class="row align-items-center mb-15" v-for="(item2, index2) in form.itens[index]">

                                        <li class="col-40 item-content item-input item-input-outline">
                                            <div class="item-inner" style="padding: 0px;">
                                                <div class="item-title ml-10">De:</div>
                                                <div class="item-input-wrap">
                                                    <input type="time" class="with-border horario" v-model="item2.inicio">
                                                    <span class="input-clear-button"></span>
                                                </div>
                                            </div>
                                        </li>
                                        
                                        <li class="col-40 item-content item-input item-input-outline">
                                            <div class="item-inner" style="padding: 0px;">
                                                <div class="item-title ml-10">Até a hora:</div>
                                                <div class="item-input-wrap">
                                                    <input type="time" class="with-border horario" v-model="item2.final">
                                                    <span class="input-clear-button"></span>
                                                </div>
                                            </div>
                                        </li>      
                                        <li class="col-20 item-content" style="padding: 0px !important;">
                                            <div class="item-inner" style="padding: 0px;">
                                                <button type="button" class="button" style="font-size: 40px; margin-top: 15px; height: 40px;" v-on:click.stop.prevent="delOpcao(index, index2, item2)">
                                                    <i class="las la-times-circle"></i>
                                                </button>
                                            </div>
                                        </li>
                                        <hr style="opacity: 0.5;">
                                    </ul>
                                </div>
                                <div class="row">
                                    <div class="col-100 mb-10 mt-10">
                                        <button type="button" class="button button-medium button-outline" v-on:click="addOpcao(index)">
                                            <i class="las la-plus"></i>
                                            Adicionar horários
                                        </button>
                                    </div>
                                </div>
                                    
                            </div>
                        </div>

                        <div class="clearfix col-100 mt-15 mb-30">
                            <button type="submit" class="link external button-large button button-fill" style="width: 100%;">
                                Salvar horários
                                <i class="las la-save ml-5"></i>
                            </button>
                        </div>
                    </div>  
                </form>                        
            </div>
        </div>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'ConfigurarAgendas',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },           
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split("T");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },      
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "agendaCod":        "",
                "itens": {
                    "d1": [                 
                    ],
                    "d2": [                 
                    ],
                    "d3": [                 
                    ],
                    "d4": [                 
                    ],
                    "d5": [                 
                    ],
                    "d6": [                 
                    ],
                    "d0": [
                    ]                   
                }
            }              
        }
    },
    methods: {
        addOpcao: function(index, index2) {
            var self        = this;
            console.log("addOpcao", self.form.itens,index, index2)

            var itens       = [
                {
                    "inicio":       "",
                    "final":        ""
                }
            ];

            if (self.form.itens[index].length == 0) {
                var i   = parseFloat(index.replace("d", ""));
                if (i == 0) i = 7;
                if ((i - 1) >= 0) {
                    if (self.form.itens["d" + (i - 1)].length > 0) {
                        itens           = self.form.itens["d" + (i - 1)];
                    }
                }
            }

            console.log("itens", itens)

            itens.forEach(function(item) {
                self.form.itens[index].push(item);
                console.log("deu push", self.form.itens[index], item)
            });
            self.$forceUpdate();
        },
        delOpcao: function(index, index2, item) {
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                self.form.itens[index].splice(index2, 1);
                self.$forceUpdate();
            });
        },
        get: function() {
            var self    = this;
            var form    = {
                params: {
                    "_cod":             self.form._cod,
                    "_token":           self.form._token,
                    "agendaCod":        self.form.agendaCod
                }
            };
            loading.show();

            axios.get("api/horario-de-atendimento.php", form).then(function(result) {

                console.log("get() result", result);

                self.form.itens = {
                    "d1": [                 
                    ],
                    "d2": [                 
                    ],
                    "d3": [                 
                    ],
                    "d4": [                 
                    ],
                    "d5": [                 
                    ],
                    "d6": [                 
                    ],
                    "d0": [
                    ]                   
                };

                result.data.result.forEach(function(item) {
                    self.form.itens["d" + item.dia].push(item);
                });

                self.$forceUpdate();
                setTimeout(function() {
                    loading.hide();
                }, 2000);

            }).catch(function(error) {
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },            
        submit: function(e) {
            var self            = this;
            console.log("submit", self.form)
            e.preventDefault();
            var err = {
                "mensagem": "",
                "el":       ""
            };

            Object.keys(self.form.itens).forEach(function(item) {

                var diaSemana;

                switch(item) {
                  case "d0":
                    diaSemana = "Domingo";
                    break;
                  case "d1":
                    diaSemana = "Segunda-feira";
                    break;
                  case "d2":
                    diaSemana = "Terça-feira";
                    break;
                  case "d3":
                    diaSemana = "Quarta-feira";
                    break;
                  case "d4":
                    diaSemana = "Quinta-feira";
                    break;
                  case "d5":
                    diaSemana = "Sexta-feira";
                    break;
                  case "d6":
                    diaSemana = "Sábado";
                    break;                                                                                                                                              
                }

                if (!err.mensagem) {
                    self.form.itens[item].forEach(function(item2, i1) {
                        if ((isNaN(parseFloat(item2.inicio.replace(":", ""))) || (isNaN(parseFloat(item2.final.replace(":", ""))))) && !err.mensagem) {
                            err.item        = item2;
                            err.mensagem    = "Erro no dia " + diaSemana + ":\n\nUm horário está inválido. Por favor, verifique e tente novamente.";
                            err.el          = $("#data-" + item);                               
                        }
                        if ((!item2.inicio || !item2.final) && !err.mensagem) {
                            err.item        = item2;
                            err.mensagem    = "Erro no dia " + diaSemana + ":\n\nUm horário está vazio. Por favor, verifique e tente novamente.";
                            err.el          = $("#data-" + item);                               
                        }
                        if (item2.inicio >= item2.final && !err.mensagem) {
                            err.item        = item2;
                            err.mensagem    = "Erro no dia " + diaSemana + ":\n\nA hora de início \"" + item2.inicio + "\" deve ser menor que a hora final \"" + item2.final + "\"";
                            err.el          = $("#data-" + item);
                        }
                        if (!err.mensagem) {
                            self.form.itens[item].forEach(function(item3, i2) {
                                if (i1 != i2) {
                                    if (item3.inicio <= item2.inicio && item3.final >= item2.final) {
                                        err.item        = item2;
                                        err.mensagem    = "Erro no dia " + diaSemana + ":\n\nA hora de início \"" + item2.inicio + "\" e a hora final \"" + item2.final + "\" estão em conflito com os outros horários do dia. Por favor, verifique e tente novamente.";
                                        err.el          = $("#data-" + item);
                                    }
                                    if (item3.inicio >= item2.inicio && item3.final <= item2.final) {
                                        err.item        = item2;
                                        err.mensagem    = "Erro no dia " + diaSemana + ":\n\nA hora de início \"" + item2.inicio + "\" e a hora final \"" + item2.final + "\" estão em conflito com os outros horários do dia. Por favor, verifique e tente novamente.";
                                        err.el          = $("#data-" + item);
                                    }   
                                    if (item3.inicio <= item2.final && item3.final >= item2.final) {
                                        err.item        = item2;
                                        err.mensagem    = "Erro no dia " + diaSemana + ":\n\nA hora de início \"" + item2.inicio + "\" e a hora final \"" + item2.final + "\" estão em conflito com os outros horários do dia. Por favor, verifique e tente novamente.";
                                        err.el          = $("#data-" + item);
                                    }                                                                       
                                }
                            });
                        }
                    });
                }
            });

            if (err.mensagem) {
                loading.hide();
                alert(err.mensagem);
                if (err.el) {
                        window.scrollTo({
                            top:            0
                        });                             
                        window.scrollTo({
                            top:            err.el[0].getBoundingClientRect().top - 70,
                            behavior:       "smooth"
                        });                         
                  
                        // $(".dashboard-content-container .simplebar-scroll-content")[0].scrollTo({
                        //     top:            err.el[0].offsetParent.offsetTop + 82,
                        //     behavior:       "smooth"
                        // });                     
                  
                }
                return false;
            }
            
            loading.show();
            axios.post("api/horario-de-atendimento.php", self.form)
            .then(response => {

                console.log("ok", response)
                self.$root.getUser().finally(function() {
                    loading.hide();
                    alert(response.data.message);
                    
                    // $(".page-content")[1].scrollTo({
                    //     top: 5
                    // });                                   

                    if (self.$route.query.tutorial) {
                        self.$root.back();
                    }
                });                

                // loading.hide();
                // alert(response.data.message);
                
                // $(".page-content")[0].scrollTo({
                //     top: 1
                // });                                   
                // if (self.$route.query.tutorial) {
                //     self.$root.back();
                // }

                // location.reload();
            })
            .catch(error => {

                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }           

    },
    beforeMount: function(e){
    },    
    activated: function() {
        var self = this;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.agendaCod = self.$route.query.c;

        self.get();
    },
    mounted: function() {
        var self            = this;

    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    .item-input {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
   
</style>



// WEBPACK FOOTER //
// src/components/ConfigurarAgendas.vue